import textIcon from "assets/icons/Icon.svg";

import UploadIcon from "../../assets/icons/document-upload.svg";

import DownloadIcon from "assets/icons/downloadIcon.svg";

import Wave from "components/audioPlayer";
import { CustomButton } from "components/component-styles/buttons/index.styled";
import RootLayout from "components/layout/rootLayout";
import ToggleOption from "components/toggleOption";
import { UploaderContainer } from "pages/convertTextToSpeech/index.styled";

import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { FiMoreVertical } from "react-icons/fi";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Wallets from "services/apis/walletsAPI";

import { env } from ".env";
import {
  AudioController,
  SelectSpeed,
} from "components/audioPlayer/index.styled";
import TextEditorEdit from "components/textEditorEdit";
import { UserInfoContext } from "contexts/userInfo";
import useWindowDimensions from "hooks/useWindowDimensions";
import Archives from "services/apis/archivesAPI";
import rialConvertToToman from "utils/convertRialToToman/convertRialToToman";
import priceSeparator from "utils/priceSeparator/PriceSeparator";
import { TextSuccess } from "pages/textEditFeedback/index.styled";
import {
  ButtonContainer,
  DashboardContainer,
  DisableWave,
  DropDownContainer,
  FileInputContainer,
  FormRow,
  ModalContainer,
  OptionContainer,
  PlayAndUpload,
  RecentFileContainer,
  RecentFileModal,
  RecentFilesCharacter,
  RecentFilesDownload,
  RecentFilesTitle,
  RecentFilesWave,
  RightContainer,
  SampleContainer,
  SelectOrRecordAudioContainer,
  TableRowCard,
  TextEditorContainer,
  TextEditorEditContainer,
  TitleContainer,
  ToggleContainer,
} from "./index.styled";
import { isDev } from "utils/logger/logger";

function ConvertSpeechToText() {
  const userData = useContext(UserInfoContext);
  const [speed, setSpeed] = useState("1");
  const [audioData, setAudioData] = useState("");
  const [file, setFile] = useState();
  const [title, setTitle] = useState();
  const [textLength, setTextLength] = useState(0);
  const [text, setText] = useState("");
  const defaultSpeaker = "1";
  const [speaker, setSpeaker] = useState(defaultSpeaker);
  const [speakerTitle, setSpeakerTitle] = useState("افرا");
  const [textTitle, setTextTitle] = useState("");
  const navigate = useNavigate();

  function handleChange(event) {
    setFile(event.target.files[0]);
    setTitle(event.target.files[0].name);
    if (event.target.files[0].type === "text/html") {
      var fr = new FileReader();
      fr.onload = () => {
        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(fr.result, "text/html");
        const sc = htmlDoc.body.querySelectorAll("script");
        const st = htmlDoc.body.querySelectorAll("style");
        const link = htmlDoc.body.querySelectorAll("link");
        const iframe = htmlDoc.body.querySelectorAll("iframe");
        sc.forEach((el) => el.remove());
        st.forEach((el) => el.remove());
        link.forEach((el) => el.remove());
        iframe.forEach((el) => el.remove());
        const temp = htmlDoc.body.innerText
          .replace(/ +(?= )/g, "")
          .replace(/(\r\n|\n|\r)/gm, "")
          .replace(/\s\s+/g, " ");

        setTextLength(temp.length);
      };
      fr.readAsText(event.target.files[0]);
    } else if (event.target.files[0].type === "text/plain") {
      var frText = new FileReader();
      frText.onload = () => {
        const le = frText.result.length;
        setTextLength(le);
      };
      frText.readAsText(event.target.files[0]);
    } else if (
      event.target.files[0].type ===
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ) {
      var frDocText = new FileReader();
      frDocText.onload = () => {
        const result = frDocText.result;
        const zip = new PizZip(result);
        const doc = new Docxtemplater().loadZip(zip);
        const text = doc.getFullText();
        setTextLength(text.length);
      };
      frDocText.readAsBinaryString(event.target.files[0]);
    }
  }

  const submitFile = async (event) => {
    event.preventDefault();

    const formData = new FormData();
    formData.append("file", file);
    formData.append("title", `${file.name}`);
    formData.append("speaker", speaker ?? defaultSpeaker);
    formData.append("speed", speed);

    const response = await new Archives(formData).postArchivesWithFile();

    if (response.type) {
      toast("اطلاعات پس از پردازش به آرشیو اضافه خواهد شد");
      const walletResponse = await new Wallets().getWallet();
      userData.setWalletData(walletResponse?.data.data.balance);
      navigate("/archive");
    } else {
      toast.error(response.message);
    }
  };

  function removeExtension(filename) {
    return filename?.substring(0, filename.lastIndexOf(".")) || filename;
  }

  // select speaker
  const onSelectChange = (e) => {
    const value = e.target.attributes.getNamedItem("speakerTitle").value;
    setSpeaker(e.target.id);
    setSpeakerTitle(value);
  };

  // add title
  const onChangeHandler = (e) => {
    setTextTitle(e.target.value);
  };

  // submit send text
  const submitText = async (values) => {
    let options = { year: "numeric", month: "long", day: "numeric" };
    let today = new Date().toLocaleDateString("fa-IR", options);

    var current_time = new Date().getHours() + ":" + new Date().getMinutes();

    const postData = {
      title: textTitle ? textTitle : `${today} - ${current_time}`,
      text: text,
      speaker: speaker || defaultSpeaker,
      speed,
    };

    const response = await new Archives(postData).postArchives();

    if (response.type) {
      toast("اطلاعات پس از پردازش به آرشیو اضافه خواهد شد");
      // context.setWalletData(context.walletData);

      const walletResponse = await new Wallets().getWallet();
      userData.setWalletData(walletResponse?.data.data.balance);

      navigate("/archive");
    } else {
      toast.error(response.message);
    }
  };

  const [toggleState, setToggleState] = useState("record");
  const [audioDownloaded, setAudioDownloaded] = useState("");

  const [calculateCostValue, setCalulateCostValue] = useState("");
  const unitOfMeasurement = userData?.usersInfo?.Plan?.data?.unitOfMeasurement;

  function calculateCost() {
    userData?.usersInfo?.Plan?.data?.rangeOfPrice.map(function (item) {
      if (file && item.from < textLength && textLength < item.to) {
        const calculate =
          Math.ceil(Number(textLength) / unitOfMeasurement) * item.price;
        setCalulateCostValue(rialConvertToToman(calculate));
      } else if (item.from < text.length && text.length < item.to) {
        const calculate =
          Math.ceil(Number(text.length) / unitOfMeasurement) * item.price;
        setCalulateCostValue(rialConvertToToman(calculate));
      }
    });
  }

  const [recentFile, setRecentFile] = useState([]);
  const getRecentFilesData = async () => {
    const params = {
      page: 1,
      count: 2,
      createdAt: "DESC",
    };

    const response = await new Archives().getArchives(params);

    if (response.type) {
      setRecentFile(response.data.data);
    }
  };

  useEffect(() => {
    getRecentFilesData();
  }, []);

  recentFile?.rows?.map((item) => {
    switch (item.status) {
      case "upload":
        item.status = "آپلود";
        break;
      case "processing":
        item.status = "در حال پردازش";
        break;
      case "success":
        item.status = "تکمیل شده";
        break;
      case "failure":
        item.status = "ناموفق";
        break;
      default:
        break;
    }
  });
  const [show, setShow] = useState(false);
  const dropdownRef = useRef(null);
  const selectHandler = () => {
    setShow(!show);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShow(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [dropdownRef]);
  const [pageTitle, setPageTitle] = useState("");

  useEffect(() => {
    if (toggleState === "file") setPageTitle("فایل");
    if (toggleState === "record") setPageTitle("ورود متن");
  }, [toggleState]);

  const speackerSampleVoicePaly = (speaker) =>{
    return(
      <Wave
        audio={`/speaker-sample/${speaker}.mp3`}
        speaker={true}
        className="wave"
      />
    )
  }

  return (
    <>
      <Helmet>
        <title>تبدیل متن به گفتار | {pageTitle}</title>
      </Helmet>

      <RootLayout>
        <DashboardContainer>
          <SelectOrRecordAudioContainer
          // padding={recentFile.count === 0 ? true : false}
          >
            <ToggleContainer
              onClick={() =>
                setToggleState((p) => (p === "record" ? "file" : "record"))
              }
            >
              <ToggleOption
                option2="ورود متن"
                option1="انتخاب فایل"
                // icon1={UploadIcon}
                // icon2={textIcon}
              />
            </ToggleContainer>

            <PlayAndUpload>
              <FileInputContainer>
                <div
                  style={{
                    flexGrow: 1,
                  }}
                >
                  {toggleState === "file" && (
                    <UploaderContainer
                      className={toggleState === "record" && "disable"}
                    >
                      <label
                        htmlFor="fileInput"
                        className={toggleState === "record" && "disable"}
                      >
                        انتخاب فایل
                      </label>
                      <input
                        id="fileInput"
                        type="file"
                        accept=".txt, .docx"
                        style={{ display: "none" }}
                        onChange={handleChange}
                        disabled={toggleState === "record" ? true : false}
                      />
                      <span
                        className={toggleState === "record" && "disableTitle"}
                      >
                        {title
                          ? removeExtension(title)
                          : "فرمت های مجاز: txt,docx"}
                      </span>
                    </UploaderContainer>
                  )}
                </div>
                <FormRow>
                  {speakerTitle ? (
                    <SampleContainer>
                      {speackerSampleVoicePaly(speaker)}
                    </SampleContainer>
                  ) : (
                    <DisableWave>
                      <Wave
                        audio="/speaker-sample/1.mp3"
                        speaker={true}
                      />
                    </DisableWave>
                  )}
                  <AudioController>
                    <SelectSpeed
                      onChange={(e) => {
                        setSpeed(e.target.value.toString());
                      }}
                    >
                      <option value="0.25">X 0.25</option>
                      <option value="0.5">X 0.5</option>
                      <option value="1" selected>
                        X 1
                      </option>
                      <option value="1.5">X 1.5</option>
                      <option value="2">X 2</option>
                      <option value="3">X 3</option>
                      <option value="4">X 4</option>
                    </SelectSpeed>
                  </AudioController>
                  <DropDownContainer onClick={selectHandler} ref={dropdownRef}>
                    <div>
                      <span>{speakerTitle}</span>
                      <MdOutlineKeyboardArrowDown
                        className={show ? "open" : ""}
                      />
                    </div>

                    <OptionContainer
                      onClick={onSelectChange}
                      className={!show ? "hidden" : ""}
                    >
                      <div id="1" speakerTitle="افرا">
                        افرا
                      </div>
                      <div id="2" speakerTitle="گرشا">
                        گرشا
                      </div>
                      <div id="3" speakerTitle="سارا">
                        سارا
                      </div>
                      <div id="4" speakerTitle="دارا">
                        دارا
                      </div>
                      <div id="5" speakerTitle="پونه">
                      پونه
                      </div>
                      <div id="6" speakerTitle="بهار">
                      بهار
                      </div>
                    </OptionContainer>
                  </DropDownContainer>
                </FormRow>
              </FileInputContainer>
              <TextEditorContainer>
                {toggleState !== "file" && (
                  <>
                    <TitleContainer
                      className={toggleState === "file" && "disable"}
                    >
                      <input
                        type="text"
                        placeholder="لطفا عنوان را وارد کنید."
                        onChange={onChangeHandler}
                        disabled={toggleState === "file" ? true : false}
                      />
                    </TitleContainer>

                    <TextEditorEditContainer
                      className={toggleState === "file" && "disable"}
                    >
                      <TextEditorEdit
                        toggleState={toggleState}
                        handleContent={(e) => setText(e)}
                        className={toggleState === "file" && "disable"}
                      />
                    </TextEditorEditContainer>
                  </>
                )}
                <ButtonContainer>
                  <div>
                    <CustomButton
                      disabledC="true"
                      onClick={toggleState === "file" ? submitFile : submitText}
                      background="#6CAEFF"
                      backgroundHover="#FFF"
                      borderColor="#6CAEFF"
                      borderColorHover="#6CAEFF"
                    >
                      ارسال
                    </CustomButton>
                    <CustomButton
                      color="#629EE8"
                      background="#fff"
                      borderSize="2px"
                      borderColor="#629EE8"
                      backgroundHover="#f4f7fc"
                      borderColorHover="#6CAEFF"
                      // disabled={toggleState === "file" && true}
                      // className={toggleState === "file" && "disabled"}
                      onClick={calculateCost}
                      type="button"
                    >
                      {calculateCostValue
                        ? `${priceSeparator(calculateCostValue)} تومان`
                        : "محاسبه هزینه"}
                    </CustomButton>
                  </div>
                </ButtonContainer>
              </TextEditorContainer>
            </PlayAndUpload>
          </SelectOrRecordAudioContainer>
          {recentFile.count !== 0 && (
            <RecentFileContainer>
              <h2>فایل های اخیر</h2>
              {recentFile?.rows?.map((item) => {
                return (
                  <TableRow
                    key={item.id}
                    row={item}
                    audioDownloaded={audioDownloaded}
                    setAudioDownloaded={setAudioDownloaded}
                  />
                );
              })}
            </RecentFileContainer>
          )}
        </DashboardContainer>
      </RootLayout>
    </>
  );
}
function TableRow({ row }) {
  const navigate = useNavigate();

  function rowOnClick(e) {
    e.stopPropagation();
    row.status === "تکمیل شده" &&
      navigate(`/convert-text-to-speech/edit/${row.id}`);
  }

  async function downloadOnClick(e) {
    e.stopPropagation();
    e.preventDefault();

    logger.log()("row.result.aiResult", row.result.aiResult);

    if (!row.result.aiResult || row.result.aiResult === "error") {
      return;
    }
    await new Archives()
      .getDownloadTextArchives(row.result.aiResult)
      .then((r) => {
        // const div = e.target;

        const a = document.createElement("a");

        const data = r.data;

        const file = new Blob([data], { type: "audio/mpeg" });

        a.href = window.URL.createObjectURL(file);

        a.download = `${row.title}.mp3`;

        // div.appendChild(a);

        a.click();

        a.remove();
      });
  }

  const dim = useWindowDimensions();
  const [audioData, setAudioData] = useState("");
  const getAudioData = async () => {
    if (!row.result.aiResult) {
      return;
    }
    await fetch(`${env.REACT_APP_BASE_URL}download/${row.result.aiResult}`, {
      // headers: {
      //   authorization: localStorage.getItem("token"),
      // },
    }).then((r) => {
      setAudioData(r.url);
    });
  };
  useEffect(() => {
    getAudioData();
  }, []);

  function removeExtension(filename) {
    return filename.substring(0, filename.lastIndexOf(".")) || filename;
  }
  // modal recent files
  const [activeModal, setActiveModal] = useState(false);
  const showModalHandler = (e) => {
    e.stopPropagation();
    setActiveModal(!activeModal);
  };

  const closeModal = (e) => {
    e.stopPropagation();
    setActiveModal(false);
  };
  return (
      <TableRowCard
        key={row.id}
        className={row.status !== "تکمیل شده" && "disable"}
        onClick={rowOnClick}
      >
        <RightContainer>
          {dim.width < 1024 && (
            <FiMoreVertical onClick={(e) => showModalHandler(e)} />
          )}
          {activeModal && dim.width < 1024 ? (
            <ModalContainer onClick={(e) => closeModal(e)}>
              <RecentFileModal>
                <div>{row?.meta_data?.textCount} کاراکتر</div>
                <div>{Math.abs(`${row.Transaction.amount}`)} ریال</div>
                <div className="download">
                  <img src={DownloadIcon} alt="download" />
                  <div
                    onClick={(e) => {
                      downloadOnClick(e);
                    }}
                  >
                    دانلود
                  </div>
                </div>
              </RecentFileModal>
            </ModalContainer>
          ) : (
            ""
          )}

          <RecentFilesTitle>{removeExtension(row.title)}</RecentFilesTitle>
          <RecentFilesCharacter>
            {rialConvertToToman(Math.abs(`${row.Transaction.amount}`))} تومان
          </RecentFilesCharacter>
          <RecentFilesCharacter>
            {row?.meta_data?.textCount} کاراکتر
          </RecentFilesCharacter>
          <RecentFilesDownload
            onClick={(e) => {
              downloadOnClick(e);
            }}
          >
            <img src={DownloadIcon} alt="download" />
            <div>
              {1024 < dim.width && dim.width < 1200
                ? "دانلود فایل"
                : "دانلود فایل صوتی"}
            </div>
          </RecentFilesDownload>
        </RightContainer>
        <RecentFilesWave
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          {row.status === "تکمیل شده" ? (
            <div>
              {audioData ? (
                <Wave audio={audioData} display="true" className="wave" />
              ) : (
                <TextSuccess>موفق</TextSuccess>
              )}
            </div>
          ) : (
            <div className="status">{row.status}</div>
          )}
        </RecentFilesWave>
      </TableRowCard>
  );
}

export default ConvertSpeechToText;
